<template>
  <!-- O segredo está no 'print-color-adjust: exact' no container principal -->
  <div 
    id="printTarifasReport"
    style="
      width: 100%; 
      font-family: Arial, sans-serif; 
      color: #000; 
      -webkit-print-color-adjust: exact; 
      print-color-adjust: exact;
    "
  >
    <!-- Cabeçalho -->
    <header
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 20px;
        padding-bottom: 10px;
      "
    >
      <img
        src="@/assets/logoBlue.png"
        alt="[logo]"
        style="width: 300px; height: auto; margin-bottom: 10px;"
      />
      <div>
        <h1 style="margin: 5px 0; font-size: 22px; font-weight: bold; text-transform: uppercase;">Relatório de Tarifas</h1>
        <div v-if="linha" style="margin-bottom: 5px;">
          <span style="font-size: 16px; font-weight: bold; color: #333;">
            {{ linha.prefixo }} — {{ linha.descricao }}
          </span>
        </div>
        <span style="font-size: 12px; color: #666;">Impresso em: {{ printedAt }}</span>
      </div>
    </header>

    <!-- Tabelas -->
    <table v-for="group in groupedItems" :key="group.key" style="
      border-collapse: collapse;
      width: 100%;
      margin-top: 20px;
      page-break-inside: auto;
      border: 1px solid #d6d6d6;
    ">
      <thead>
        <!-- Origem com fundo escuro para destaque na impressão -->
        <tr>
          <th colspan="5" style="
            padding: 10px;
            text-align: left;
            color: #000000 !important;
            font-size: 14px;
            border: 1px solid #d6d6d6;
          ">
            <strong>{{ group.origem }}</strong>
          </th>
        </tr>
        <!-- Cabeçalho das Colunas -->
        <tr>
          <th style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: left; width: 25%;">Para</th>
          <th style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: left;">Serviço</th>
          <th style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: center;">Valor</th>
          <th style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: center;">Vigência</th>
          <th style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: center;">Sentido</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(destino) in group.destinos">
          <tr
            v-for="(item, index) in destino.items"
            :key="`${destino.key}-${item.id}`"
            style="page-break-inside: avoid;"
          >
            <!-- Coluna Destino -->
            <td
              v-if="index == 0"
              :rowspan="destino.items.length"
              style="
                padding: 8px;
                font-weight: bold;
                border: 1px solid #d6d6d6;
                vertical-align: middle;
                background-color: #ffffff;
                font-size: 14px;
              "
            >
              {{ destino.destino }}
            </td>
            
            <td style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px;">
              {{ item.servico }}
            </td>
            <td style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; font-weight: bold; text-align: center;">
              {{ convertCurrent(item.valor) }}
            </td>
            <td style="padding: 8px; border: 1px solid #d6d6d6; font-size: 12px; text-align: center;">
              {{ convertDate(item.data_vigencia) }}
            </td>
            <td style="padding: 8px; border: 1px solid #d6d6d6; font-size: 11px; text-align: center; text-transform: uppercase;">
              {{ convertSentido(item.sentido) }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["items", "linha"],
  computed: {
    printedAt() {
      return this.formatDateTime(new Date());
    },
    groupedItems() {
      const groups = [];

      this.items.forEach((item) => {
        const key = `${item.origem}`;
        let group = groups.find((data) => data.key == key);

        if (!group) {
          group = {
            key,
            origem: item.origem_nome,
            destinos: [],
          };
          groups.push(group);
        }

        const destinoKey = `${item.origem}-${item.destino}`;
        let destino = group.destinos.find((data) => data.key == destinoKey);

        if (!destino) {
          destino = {
            key: destinoKey,
            destino: item.destino_nome,
            items: [],
          };
          group.destinos.push(destino);
        }

        destino.items.push(item);
      });

      return groups;
    },
  },
  methods: {
    convertDate(date) {
      if (!date) return "";
      return date.split("-").reverse().join("/");
    },
    convertCurrent(value) {
      const parsedValue = Number(value);
      return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(isNaN(parsedValue) ? 0 : parsedValue);
    },
    convertSentido(sentido) {
      return sentido == 0 ? "Ida" : sentido == 1 ? "Volta" : "Ida e Volta";
    },
    formatDateTime(date) {
      return new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
        .format(date)
        .replace(",", "");
    },
  },
};
</script>
